import { render, staticRenderFns } from "./MarketSign.vue?vue&type=template&id=51f57c88&scoped=true"
import script from "./MarketSign.vue?vue&type=script&lang=js"
export * from "./MarketSign.vue?vue&type=script&lang=js"
import style0 from "./MarketSign.vue?vue&type=style&index=0&id=51f57c88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f57c88",
  null
  
)

export default component.exports